import { IReduxStore } from "Redux/Store/IReduxStore";

export const getLastSpotListId = (state: IReduxStore) => state.spotList.lastInteractiveId;